import store from "@/store";
import { Action, Module, VuexModule } from "vuex-class-modules";
import { AgentData } from "@/models/AgentData";
import { AccountService } from "@/services/AccountService";
import { LoginModel } from "@/models/LoginModel";

@Module({ generateMutationSetters: true })
class AccountStore extends VuexModule {
  user: AgentData | null = null;
  service: AccountService = new AccountService();

  get isLoggedIn(): boolean {
    return this.user !== null;
  }

  @Action
  async logOff(): Promise<void> {
    await this.service.logoff();
    this.user = null;
  }

  @Action
  async login(loginModel: LoginModel): Promise<boolean> {
    if (!this.isLoggedIn) {
      this.user = await this.service.login(loginModel);
    }
    return this.isLoggedIn;
  }

  @Action
  async getLoggedInUser(): Promise<boolean> {
    if (!this.isLoggedIn) {
      this.user = await this.service.getLoggedInUser();
    }
    return this.isLoggedIn;
  }
}

export const accountStore = new AccountStore({ store, name: "account" });
